module.exports = __webpack_public_path__ + "img/ic_instructions.860f73e0.png";